import { apiGet } from '@/shared/utils/requestBuilder';
import type { Comarca, ComarcaFilters } from '@/types/comarca/comarcaTypes';

class ComarcaService {
  private baseUrl = '/comarcas';

  async listar(filters?: ComarcaFilters) {
    const params: Record<string, string | number | boolean> = {};

    if (filters?.tribunalId) params.tribunalId = filters.tribunalId;
    if (filters?.uf) params.uf = filters.uf;
    if (filters?.ativo !== undefined) params.ativo = filters.ativo;
    if (filters?.search) params.search = filters.search;
    if (filters?.page) params.page = filters.page;
    if (filters?.limit) params.limit = filters.limit;

    const response = await apiGet(this.baseUrl, params);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error?.message || 'Erro ao listar comarcas');
    }

    return {
      data: data.data as Comarca[],
      total: data.pagination?.total || data.data.length,
      page: data.pagination?.page || 1,
      limit: data.pagination?.limit || 100,
    };
  }

  async buscarPorTribunal(tribunalId: string): Promise<Comarca[]> {
    const response = await apiGet(`${this.baseUrl}/tribunal/${tribunalId}`);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error?.message || 'Erro ao buscar comarcas');
    }

    return data.data as Comarca[];
  }

  async buscar(id: string): Promise<Comarca> {
    const response = await apiGet(`${this.baseUrl}/${id}`);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error?.message || 'Erro ao buscar comarca');
    }

    return data.data as Comarca;
  }
}

export const comarcaService = new ComarcaService();
